import React, { useState, ReactElement, useEffect, useRef } from "react";
import { TextField, Button, Grid, Container, Typography, Card, CardActionArea, CardMedia, CardContent, Box, Tab, Tabs } from "@mui/material";
import {
  InputField,
  QuestionContainer,
  Question,
  CommentsText,
  RadioButtons,
  WordLimit,
  ButtonOption,
  Sliders,
  SliderContainer,
  SliderValue,
  RadioRow,
  RadioLabel,
  SliderLabel
} from "./dynamicQuestionField.styled"
import Slider from '@mui/material/Slider';


function DynamicQuestionField(props) {

  const CustomSliderStyles = {
    '& .MuiSlider-thumb': {
      color: "#A100FF"
    },
    '& .MuiSlider-track': {
      color: "grey"
    },
    '& .MuiSlider-rail': {
      color: "grey"
    }
  };

  const [selectedValue, setSelectedValue,] = useState("Yes");
  const [coverage, setCoverage] = React.useState<number>(30);
  const [effectiveness, setEffectiveness] = React.useState<number>(30);
  const [remarks, setRemarks,] = useState("");
  const [isSliderDisabled, setIsSliderDisabled] = useState(false)

  const handleRadioChange = (value) => {
    setSelectedValue(value);

    if (value === "N/A" || value === 'No') {
      setCoverage(0)
      setEffectiveness(0)
      setIsSliderDisabled(true)
    } else {
      setIsSliderDisabled(false)
    }
  };

  const handleCoverage = (event: Event, newValue: number) => {
    setCoverage(newValue);
  };

  const handleEffectiveness = (event: Event, newValue: number) => {
    setEffectiveness(newValue);
  };

  useEffect(() => {
    if (props.data[props.itemHeader]) {
      let question = props.data[props.itemHeader]
      handleRadioChange(question[props.item].Response)
      setCoverage(question[props.item].Coverage)
      setEffectiveness(question[props.item].Effectiveness)
      setRemarks(question[props.item].Remarks)
    }

  }, [props.data])

  return (
    <QuestionContainer>
      <Question key={props.index}>{props.item}</Question>
      <RadioRow>
        <RadioButtons>
          <ButtonOption>
            <input type="radio" id="Yes" value="Yes" checked={selectedValue === "Yes"} onChange={() => handleRadioChange("Yes")} />
            <RadioLabel htmlFor="Yes">Yes</RadioLabel>
          </ButtonOption>
          <ButtonOption>
            <input type="radio" id="No" value="No" checked={selectedValue === "No"} onChange={() => handleRadioChange("No")} />
            <RadioLabel htmlFor="No">No</RadioLabel>
          </ButtonOption>
          <ButtonOption>
            <input type="radio" id="N/A" value="N/A" checked={selectedValue === "N/A"} onChange={() => handleRadioChange("N/A")} />
            <RadioLabel htmlFor="N/A">N/A</RadioLabel>
          </ButtonOption>
        </RadioButtons>
        <Sliders>
          <SliderContainer>
            <SliderLabel>Coverage</SliderLabel>
            <Slider disabled={isSliderDisabled} style={{ width: "8em" }} aria-label="Volume" value={coverage} onChange={handleCoverage} sx={CustomSliderStyles} />
            <SliderValue>{coverage}</SliderValue>
          </SliderContainer>
          <SliderContainer>
            <SliderLabel>Effectiveness</SliderLabel>
            <Slider disabled={isSliderDisabled} style={{ width: "8em" }} aria-label="Volume" value={effectiveness} onChange={handleEffectiveness} sx={CustomSliderStyles} />
            <SliderValue>{effectiveness}</SliderValue>
          </SliderContainer>
        </Sliders>
      </RadioRow>
      <div>
        <CommentsText>Additional Coments (Optional)</CommentsText>
      </div>
      <div style={{ display: "flex" }}>
        <InputField id="remarks" name="remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)}></InputField>
        <WordLimit>50 word limit</WordLimit>
      </div>
    </QuestionContainer>
  );
}

export default DynamicQuestionField;